import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Title } from "../../../../../stories/Title/Title";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import { LicenseTypes, Operation } from "../../../../../utils/Enum.types";
import Navbar from "../../../../common/layout/Navbar";
import React, { useEffect, useState } from "react";
import DownArrow from "../../../../../images/DownArrow.svg";
import Edit from "../../../../../images/EditProfile.svg";
import DeleteImg from "../../../../../images/Delete.svg";
import { useLazyQuery, useMutation } from "@apollo/client";

import { getPredefinedDataByTypes } from "../../../../../queries/queries";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";
import { Keys, SpecialKeys } from "../../../../../utils/Enum.keys";
import { Button } from "../../../../../stories/Button/Button";
import {
  AddPredefinedDataType,
  getPredefinedDataByType,
} from "./queries/queries";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import table_Header from "../../json/table.json";
import {
  DeletePredefinedDataByIdResult,
  DeletePredefinedDataByIdVar,
  PredefinedDataByTypeData,
  PredefinedDataByTypeVars,
  PredefinedDataEdge,
  PredefinedDataOrderField,
} from "./queries/types";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import Modal from "react-modal";
import { EditModalStyles } from "../../../../../styles/CustomModalStyles";
import AddPredefinedList from "./Add";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { DeletePredefinedDataById } from "./queries/mutation";
import MessageModal from "../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../pages/LoadingModal";
import { getModifiedScrollHeight } from "../../../../../utils/UtilFunctions";
import { useNavigate } from "react-router-dom";
import { useHotKey } from "../../../../../utils/hotKeys";

const PredefinedList = () => {
  const [selectedType, setSelectedType] = useState("");
  const [type, setType] = useState("");
  const navigate=useNavigate();
  const [message, setMessage] = useState(emptyMessage);
  const [operationType, setOperationType] = useState<Operation>(Operation.NONE);
  const [predefinedModal, setPredefinedModal] = useState(false);
  const [predefinedId, setPredefinedId] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [categories, setCategories] = useState<PredefinedDataEdge[]>([]);

 
  const { user_details } = useLoggedInUserDetails();

  const [GetPredefindedData, PredefinedDataByTypes] = useLazyQuery(
    getPredefinedDataByTypes
  );

  const [AddPredefinedDataTypeOnly, { loading: addPredefinedDataTypeLoading }] =
    useMutation(AddPredefinedDataType, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    });

  const [
    PredefinedDataByType,
    { data, loading: predefinedDataTypeByLoading, fetchMore },
  ] = useLazyQuery<PredefinedDataByTypeData, PredefinedDataByTypeVars>(
    getPredefinedDataByType
  );

  const [DeletePredefinedData, { loading: deletePredefinedDataLoading }] =
    useMutation<DeletePredefinedDataByIdResult, DeletePredefinedDataByIdVar>(
      DeletePredefinedDataById,
      {
        onError: (e) => {
          setMessage({
            message: e.message,
            flag: true,
            operation: Operation.NONE,
          });
        },
      }
    );

  useEffect(() => {
    GetPredefindedData();
  }, [GetPredefindedData]);

  const preDefinedDropdown =
    PredefinedDataByTypes?.data &&
    PredefinedDataByTypes?.data?.GetPredefinedDataTypes.map(
      (option: string) => option
    );

  const handleAddPredefinedDataType = async () => {
 
    if (type) {
      await AddPredefinedDataTypeOnly({
        variables: {
          
          user_details,
          data_type: type,
        },
        refetchQueries: [
          {
            query: getPredefinedDataByType,
            variables: {
              
              type: selectedType,
              after: null,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: PredefinedDataOrderField.CREATED_AT,
              },
            },
          },
        ],
      }).then(({ data }) => {
        if (data) {
          setMessage({
            message: "Pred-Defined Data Added Successfully",
            flag: true,
            operation: Operation.CREATE,
          });
        }
      });
    }
  };

  useEffect(() => {
    if (selectedType) {
      PredefinedDataByType({
        variables: {
          after: null,
          type: selectedType,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: PredefinedDataOrderField.CREATED_AT,
          },
          
          name: "",
        },
      });
    }
  }, [selectedType, PredefinedDataByType]);

  useEffect(() => {
    if (data && !predefinedDataTypeByLoading) {
      const newData = data.GetPredefinedDataByType.edges;
      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = categories.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setCategories(updatedNewData);
      } else {
        setCategories(newData);
      }
      setEndCursor(data.GetPredefinedDataByType.pageInfo.endCursor);
    }
  }, [data, predefinedDataTypeByLoading]);

  const handleScroll = async (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;
    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !predefinedDataTypeByLoading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetPredefinedDataByType.edges;
            const pageInfo = fetchMoreResult.GetPredefinedDataByType.pageInfo;
            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck =
              prevResult.GetPredefinedDataByType.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

            if (duplicateCheck.length > 0) return prevResult;

            return {
              GetPredefinedDataByType: {
                edges: [...categories, ...newEdges],
                pageInfo,
                totalCount: data ? data.GetPredefinedDataByType.totalCount! : 0,
              },
            };
          },
        });
      }
    }
  };

  const HandleDelete = async () => {
    try {
     
        setDeleteModal(!deleteModal);
        await DeletePredefinedData({
          variables: {
            
            id: String(predefinedId),
            user_details,
          },
          refetchQueries: [
            {
              query: getPredefinedDataByType,
              variables: {
                
                type: selectedType,
                after: null,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: PredefinedDataOrderField.CREATED_AT,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data) {
            setMessage({
              message: "Pre-Defined Data Deleted successfully",
              flag: true,
              operation: Operation.DELETE,
            });
          }
        });
      
    } catch (error) {}
  };

  const handleClose = () => {
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  useHotKey({
    handleFunc: () => {
      setOperationType(Operation.CREATE);
      setPredefinedModal(!predefinedModal);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.ADMIN} />
      <Title>Predefined List</Title>
      <div className="predefined">
      <div className="row g-0 predefined__select">
        <div className="col-3 ">
          <FormAutocomplete
            className={formClasses.inputRoot}
            options={preDefinedDropdown! ?? [""]}
            openOnFocus
            value={selectedType}
            onChange={(e, newValue) => {
              if (newValue) {
                setSelectedType(newValue as string);
              } else {
                setSelectedType(EMPTY_STRING);
              }
            }}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === Keys.BACKSPACE) {
                setSelectedType("");
              }
            }}
            forcePopupIcon
            freeSolo
            popupIcon={<img src={DownArrow} />}
            renderInput={(params) => (
              <TextField
                onChange={(e) => {
                  setType(e.target.value);
                }}
                {...params}
                fullWidth
                className={formClasses.formControlRoot}
              />
            )}
          />
        </div>
        <div className="col-2">
          <Button
            mode="predefined-type"
            onClick={() => {
              handleAddPredefinedDataType();
              setMessage({
                message: "",
                flag: false,
                operation: Operation.NONE,
              });
            }}
          />
        </div>
        <div className="col flex-end">
          <Button
            mode="addnew"
            type="button"
            autoFocus
            onClick={() => {
              setOperationType(Operation.CREATE);
              setPredefinedModal(!predefinedModal);
            }}
          />
        </div>
      </div>
      <div className="predefined__tableblock">
        <TableContainer className="predefined__table" onScroll={handleScroll}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {table_Header.Settings_Table.PredefinedList.Table_Headers.map(
                  (th, index: React.Key) => {
                    return (
                      <React.Fragment key={index}>
                        <TableCell>{th.labelName}</TableCell>
                      </React.Fragment>
                    );
                  }
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {data && selectedType
                ? data.GetPredefinedDataByType.edges.map(
                    (data, index: React.Key) => {
                      return (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell>{data.node.id}</TableCell>
                            <TableCell>{data.node.index}</TableCell>
                            <TableCell>{data.node.type}</TableCell>
                            <TableCell>{data.node.value1}</TableCell>
                            <TableCell>{data.node.value2}</TableCell>
                            <TableCell>{data.node.value3}</TableCell>
                            <TableCell>{data.node.value4}</TableCell>
                            <TableCell>
                              <img
                                src={Edit}
                                alt="/"
                                onClick={() => {
                                  setPredefinedId(Number(data.node.id));
                                  setOperationType(Operation.UPDATE);
                                  setPredefinedModal(!predefinedModal);
                                }}
                              />
                              <img
                                src={DeleteImg}
                                alt="/"
                                onClick={() => {
                                  setPredefinedId(Number(data.node.id));
                                  setDeleteModal(!deleteModal);
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    }
                  )
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Button mode="back" onClick={()=>navigate(-1)}/>
      </div>
    

      

      <Modal isOpen={predefinedModal} style={EditModalStyles}>
        <AddPredefinedList
          operationType={operationType}
          PredefinedDataByTypes={PredefinedDataByTypes}
          setPredefinedModal={setPredefinedModal}
          predefinedModal={predefinedModal}
          setSelectedType={setSelectedType}
          predefinedId={predefinedId}
          getPredefinedDataByType={getPredefinedDataByType}
        />
      </Modal>

      <DeleteModal
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
        id={predefinedId}
      />

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />

      <LoadingModal
        flag={
          predefinedDataTypeByLoading ||
          addPredefinedDataTypeLoading ||
          deletePredefinedDataLoading
        }
      />
    </>
  );
};

export default PredefinedList;
